module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/nodata-77fd47816d96874f0e91ba6c2a1e6694.png";